var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 13.0622V16.5001H3.43796L13.5822 6.35581L10.1443 2.91785L0 13.0622Z",
    fill: "#3CB4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2329 2.40885L14.0922 0.268161C13.7346 -0.0893871 13.1525 -0.0893871 12.7949 0.268161L11.1172 1.94589L14.5552 5.38385L16.2329 3.70613C16.5905 3.34858 16.5905 2.7664 16.2329 2.40885Z",
    fill: "#3CB4E5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.44ad105267df22ef89fb8c75d9f8ff8b.svg";
export { ForwardRef as ReactComponent };